import * as Utils from './savanna_utils.js';

export function destroy_user() {
	console.log('clearing localstorage');
	localStorage.clear();
	window.language_loaded = false;
	window.holidays_loaded = false;
	window.loggend_in_employee_codes_loaded = false;
	window.global_user_has_access_feature_list = {};

	
}



